const o = (t, c, n = "…") => {
  if (!t || t.length <= c)
    return t;
  const i = t.slice(0, Math.floor(c / 2) - Math.floor(n.length / 2)), l = t.slice(-1 * Math.ceil(c / 2) + Math.ceil(n.length / 2));
  return `${i}${n}${l}`;
};
export {
  o as truncateMiddle
};
//# sourceMappingURL=truncateMiddle.mjs.map
